import { Language, TranscriptSpeaker } from "@/types/__generated__/union-types"

export type ConnectionStatus = "disconnected" | "connecting" | "connected"

export type AudioSource = "microphone" | "speaker" | "remoteTrack"

export type { TranscriptSpeaker }

export type TranscriptEntry = {
  id: string
  text: string
  timestamp: number
  isFinal: boolean
  speaker: TranscriptSpeaker
}

export type SpeechToTextConfig = {
  endpoint: string
  sampleRate: number
  language: Language
  languageLocale: string
  format: "simple" | "detailed"
}

export const LANGUAGE_LOCALES: Record<Language, string> = {
  ENGLISH: "en-US",
  GERMAN: "de-DE",
  FRENCH: "fr-FR",
  ITALIAN: "it-IT",
}
